import { SaveButton, Toolbar, ToolbarProps, useGetIdentity } from 'react-admin';
import DeleteDriverButton from './delete-driver-button';
import ReactivateDriverButton from './reactivate-driver-button'
import { getAuthorType } from './helpers/helpers';

export const EditDriverToolbar:React.FC<ToolbarProps> = (props)=> {
  const { identity } = useGetIdentity();
  const authorType = getAuthorType(identity);
  if (props.record) {
    props.record.audit_logs = { reference_id: props.record.id, type: 'driver', author_type: authorType, author: identity?.email };
  }
  const isSupportTier2 = identity?.driverRoles.includes('support_tier2')

  return (<Toolbar {...props } style={{justifyContent: 'space-between'}}>
    <SaveButton
      label="save"
      redirect="show"
      submitOnEnter={true}
    />
    { !isSupportTier2 ?
      ( props.record?.active ?
        <DeleteDriverButton {...props} /> :
        <ReactivateDriverButton {...props} />
      ) : null
    }
  </Toolbar>)
};
